var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-hand"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
})));
export default SvgHand;